import DockButton from '~/components/DockButton'
import DockShareLink from '~/components/DockShareLink'
import Flex from '~/components/Flex'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { WarningSignIcon } from '~/icons/evergreen'
import { useActions, useStore } from '~/store/hooks'
import { toggleDrawer } from '~/utils/toggles'

export default function DockStateErrored() {
  const access = useStore(state => state.ref.access)
  const toggles = useStore(actions => actions.hud.toggles)
  const toggle = useActions(actions => actions.hud.toggle)

  const friendlyError = {
    NEED_APP: 'Netlify GitHub App not installed',
    NEED_GITLAB_TOKEN: 'Netlify needs your GitLab token',
    NEED_BITBUCKET_TOKEN: 'Netlify needs your Bitbucket token',
    NEED_ADO_TOKEN: 'Netlify needs your Azure DevOps token',
  }

  return (
    <>
      <Flex justifyContent="flex-start">
        <ToolGroup>
          <Tool
            active={false}
            iconBefore={<WarningSignIcon color="warning" size={16} />}
            label={friendlyError[access] || 'Something went wrong'}
            // name="drawer"
            onClick={() => toggleDrawer(toggles, toggle)}
          />
        </ToolGroup>
      </Flex>
      <Flex>
        <DockShareLink />
        <DockButton border="left" />
      </Flex>
    </>
  )
}
